const {gql} = require('graphql-tag');
export default gql`
  mutation removeFilmToPerson($id: ID!) {
    removeFilmToPerson(id: $id) {
      id
    }
  }
`;
